'use client';

// Produktkort med bilde for affiliate-produkter. Hele kortet er én lenke —
// bilde, navn og knapp fører samme sted og spores likt, så et klikk på bildet
// teller like mye som et klikk på knappen.
// Typen speiles her bevisst i stedet for å importeres fra lib/affiliate:
// en klientkomponent som importerer fra en modul serverkomponenten også bruker,
// ga chunk-lastingsfeil i dev (webpack options.factory).
type AffiliateProduct = {
  navn: string;
  bilde: string;
  alt: string;
  pris: number;
  prisSjekket: string;
  url: string;
  passerTil: string;
};

export function AffiliateProductCards({ produkter, source }: { produkter: AffiliateProduct[]; source: string }) {
  const track = (navn: string) => {
    const w = window as unknown as { gtag?: (...args: unknown[]) => void };
    w.gtag?.('event', 'affiliate_click', { item_name: navn, article: source, partner: 'tradedoubler', placement: 'produktkort' });
  };

  return (
    <div className="not-prose my-8">
      <p className="text-[11px] font-bold text-stone-400 uppercase tracking-widest mb-3">
        Modellene nevnt over · annonselenker
      </p>
      <div className="grid sm:grid-cols-2 gap-4">
        {produkter.map((p) => (
          <a
            key={p.url}
            href={p.url}
            onClick={() => track(p.navn)}
            target="_blank"
            rel="sponsored nofollow noopener noreferrer"
            className="group flex flex-col bg-white border border-stone-200 rounded-2xl p-4 hover:border-amber-300 hover:shadow-md transition-all"
          >
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={p.bilde}
              alt={p.alt}
              loading="lazy"
              width={515}
              height={515}
              className="w-full aspect-square object-contain bg-stone-50 rounded-xl mb-3"
            />
            <p className="font-semibold text-stone-900 text-sm leading-snug">{p.navn}</p>
            <p className="text-xs text-stone-600 mt-1.5 leading-relaxed flex-1">{p.passerTil}</p>
            <p className="text-xs text-stone-400 mt-3">
              ca. {p.pris.toLocaleString('no')} kr · pris sjekket {p.prisSjekket}
            </p>
            <span className="mt-2 inline-flex items-center justify-center gap-1 w-full py-2.5 rounded-xl bg-stone-900 text-white text-sm font-semibold group-hover:bg-stone-800 transition-colors">
              Se hos Philips →
            </span>
          </a>
        ))}
      </div>
    </div>
  );
}
